<mat-card class="example-card">
  <mat-card-header
    class="titreFrm items-center"
    style="padding: 2em 0em !important"
  >
    <mat-card-title>LISTE {{ client }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <div *ngIf="!showButton" class="btn">
      <div class="button-row">
        <button
          type="button"
          (click)="choisirDocument()"
          mat-raised-button
          class="colorGreen button-row"
        >
          <mat-icon>mouse</mat-icon>Choisir
        </button>
      </div>
      <div class="button-row">
        <button
          type="button"
          (click)="generalService.dialogOpend.close()"
          mat-raised-button
          class="colorRed button-row"
        >
          <mat-icon>close</mat-icon>Fermer
        </button>
      </div>
    </div>
    <div *ngIf="showButton" class="btn mr-8">
      <!-- <div>
        <mat-radio-group [ngClass]="param == '3'? 'display-none' : ''" (change)="radioTypeChange($event)" name="dd" [(ngModel)]="param" required>
          <mat-radio-button  [disabled]="!exist" value="1">CLIENTS</mat-radio-button>
          <mat-radio-button  [disabled]="!exist" value="2">PROSPECTS</mat-radio-button>
        </mat-radio-group>        
      </div> -->

      <div class="btn2">
        <div class="button-row">
          <button
            [disabled]="!exist"
            (click)="afficher(2)"
            mat-raised-button
            class="colorBlue"
          >
            <mat-icon>edit</mat-icon>
            Modifier
          </button>
        </div>
        <!-- <div class="button-row">
            <button [disabled]="!exist" (click)="afficher(3)" mat-raised-button class="colorGray">
              <mat-icon>import_contacts</mat-icon>
              Consulter
            </button>
          </div> -->
        <div class="button-row">
          <button
            [disabled]="!exist"
            (click)="supprimer()"
            mat-raised-button
            class="colorRed"
          >
            <mat-icon>delete</mat-icon>
            Supprimer
          </button>
        </div>
        <div class="button-row">
          <button
            [disabled]="!exist"
            type="button"
            (click)="exportToExcel()"
            mat-raised-button
            class="colorGreen"
          >
            <mat-icon>arrow_downward</mat-icon>Export Excel
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="showTableClient">
      <!--app-avt-listes 
          [multipleSelect]="false" 
          #listeClientComponen 
          [showFilter]="true" [heightTable]="'400'" 
          [dataSourceBrut]="dataSource" 
          [displayedColumnsBrut]="columns" >
        </app-avt-listes-->
      <app-liste
        #listeClientComponen
        [showSort]="true"
        [showFilter]="true"
        [maxHeight]="400"
        [dataSource]="dataSource"
        [columns]="columns"
      >
      </app-liste>
    </div>
  </mat-card-content>
</mat-card>
